import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  en: {
    mobile: {
      welcome: 'Welcome to NetOX',
      subtitle: 'Recommendation',
      warning:
        'At this stage, your experience will be better if you access from a desktop device.',
      close: 'Close',
    },
    sidebar: {
      home: 'Home',
      dashboard: 'Dashboard',
      usefulLinks: 'Useful Links',
      disclaimer: 'Disclaimer',
      discover: 'Discover more tools',
    },
    navbar: {
      login: 'Login',
      hi: 'Hi',
      logout: 'Logout',
      profile: 'Personal Settings',
      myapnic: 'MyAPNIC Dashboard',
      training: 'Training',
      academy: 'Academy',
      blog: 'Blog',
      internetDirectory: 'Internet Directory',
    },
    searchBox: {
      title: 'NetOX',
      subtitle: "Network Operators' toolboX",
      subHeader:
        'A set of tools to analyse your— and other— networks to solve routing issues, and make better-informed decisions',
      eg: 'E.g.',
      search: 'Search',
      or: 'or',
      searchHint: 'Enter Internet number resource',
      warningText: 'Enter a valid format. E.g.:AS15169 or 8.8.8.0/24',
    },
    welcomePage: {
      discoverMore: 'Discover more',
      tools: {
        title: 'Discover all tools',
        description: 'Explore categories to get a summary of each tool set',
      },
      startUsing:
        'Start using NetOX now to solve routing issues and make better-informed decisions',
      exampleTitle: 'The dashboard is displaying data for | as an example',
      otherNetworkInfo: {
        title: 'Other network information',
        description:
          'Find routing information for deciding which other networks to connect to',
        items: [
          {
            text: 'Who has more peers, AS1 or AS2?',
            link: 'View the At a glance category',
            example:
              'The CAIDA AS relationship is the tool that informs about the peers for a given AS. | Use the search box for entering another AS.',
          },
          {
            text: 'How does the upstream outage look?',
            link: 'View the Routing category',
            example:
              'These are the tools that provide information related to the impact on BGP routing of an outage. | Use the search box for entering another prefix.',
          },
          {
            text: 'Is the prefix or ASN that you want already visible in BGP?',
            link: 'View the Quality Check category',
            example:
              'These are the tools that provide information to assess the quality of resources in terms of routing among others. | Use the search box for entering another AS or prefix.',
          },
          {
            text: 'Which ASN announces an IP?',
            link: 'View the Routing category',
            example:
              'These are the tools that provide information related to the announcements of a perfix or AS. | Use the search box for entering another prefix.',
          },
          {
            text: 'Where can you report abuse from an IP?',
            link: 'View the Anti Abuse category',
            example:
              'These are the tools that provide information about blacklisted IP resources and points of contact to report abuse. | Use the search box for entering another prefix.',
          },
        ],
      },
      yourNetworkInfo: {
        title: 'Your network information',
        description:
          'Find routing information to debug and troubleshoot your networks',
        items: [
          {
            text: 'Is someone else announcing your prefix?',
            link: 'View the Routing category',
            example:
              'These are the tools that provide information related to the announcements of a prefix or AS. | Use the search box for entering your prefix or AS.',
          },
          {
            text: 'How visible is your new IPv6 network?',
            link: 'View the Routing category',
            example:
              'These are the tools that provide information related to the visibility of a prefix or AS. | Use the search box for entering your prefix or AS.',
          },
          {
            text: 'Is your BGP routing consistent with the Routing Registry?',
            link: 'View the Routing category',
            example:
              'These are the tools that provide information related to BGP routing. | Use the search box for entering your prefix.',
          },
          {
            text: 'Has your prefix been blacklisted?',
            link: 'View the Anti Abuse category',
            example:
              'These are the tools that provide information about blacklisted IP resources and points of contact to report abuse. | Use the search box for entering your prefix.',
          },
          {
            text: 'Was your prefix visible yesterday in a specific economy?',
            link: 'View the Geographic category',
            example:
              'These are the tools that provide current and historical geolocation information. | Use the search box for entering your prefix.',
          },
        ],
      },
      poweredBy: 'Powered by | RIPE NCC’s RIPEstat',
    },
    discoverPage: {
      header: 'Discover more tools',
      title: 'Get further information about your and other networks',
      p1: 'Check out these free tools to help solve your routing issues and make better-informed network decisions.',
      p2: 'To further analyse the selected Internet number resource, and validate this information with a different source:',
      p3: 'Hurricane Electric’s BGP toolkit',
      p4: 'Explore the Resource Public Key Infrastructure (RPKI) information of the selected Internet number resource with:',
      p5: 'Cloudflare’s RPKI',
      p6: 'Get tools and APIs for viewing live and historical BGP data with:',
      p7: 'CAIDA’s BGPstream',
      p8: 'Stay tuned about BGP events such as outages or hijacks in the following Twitter account:',
      p9: 'Cisco’s BGPstream Twitter account',
      p10: 'Find information about the IPv6 users of an AS. It may help when choosing networks to connect to or when hiring upstream providers:',
      p11: 'APNIC Labs IPv6 populations',
      p12: 'Identify and troubleshoot Resource Public Key Infrastructure (RPKI) related issues involving the selected Internet number resource with:',
      p13: "NLnet Labs' JDR",
    },
    disclaimerPage: {
      header: 'Disclaimer',
      p1: 'Although APNIC takes all reasonable care to ensure the accuracy and validity of this data, we do not control, and therefore guarantee, the complete accuracy, completeness and availability of the data.',
      p2: 'The widgets in this site consume data from external data sources which APNIC does not verify. It is not intended that these widgets be considered as an authoritative statement of any kind, but they should be used as an informational service only.',
      p3: 'In particular, for the Resource Quality Check section, the widgets included in that section are intended to assist in assessing the quality of resources, but such quality cannot be guaranteed. You should conduct your own investigations before relying on any information or date provided at this website.',
      p4: 'APNIC does not assume any liability for any loss or damage that may arise from the use of this data.',
    },
    tabs: {
      'apnic-at-a-glance': {
        name: 'At a glance',
        info: 'Key tools to give you a quick overview of an AS or prefix',
      },
      'apnic-rqc': {
        name: 'Quality Check',
        info: 'Tools providing information to assess the quality of resources in terms of delegation, routing, geolocation and blacklisting status',
      },
      'apnic-routing': {
        name: 'Routing',
        info: 'Tools providing information related to BGP routing',
      },
      'apnic-anti-abuse': {
        name: 'Anti Abuse',
        info: 'Tools providing information about blacklisted IP resources and points of contact to report abuse',
      },
      'apnic-database': {
        name: 'Database',
        info: 'Tools providing registry information (WHOIS and IRR information)',
      },
      'apnic-geo': {
        name: 'Geographic',
        info: 'Tools providing current and historical geolocation information',
      },
      'apnic-activity': {
        name: 'Activity',
        info: 'Tools providing information about network and Internet measurements activity',
      },
      'apnic-experimental': {
        name: 'Experimental',
        info: 'no info',
      },
      'apnic-comparison': {
        name: 'Comparison',
        info: 'Compare results for different Internet number resources',
      },
    },
    experimentalMsg: {
      title:
        'You are viewing new tools that we are testing for knowing how valuable they are for you. At this stage, you may experience some issues.',
      body: 'This is an experimental page for knowing how valuable these tools are for you. This page presents data that comes from a third party, and you may experience some issues. We are sorry for any inconvenience.',
    },
    footer: {
      privacy: 'Privacy',
      contact: 'Contact',
      helpdesk: 'Help Center',
      nroNews: 'NRO News',
      serviceStatus: 'Service Status',
      careers: 'Careers',
      connect: 'Connect with us',
    },
    comparisonFeature: {
      resources: {
        tab: 'Step 1',
        title: 'Enter the Internet number resources you want to compare:',
        inputPlaceholder: 'Enter Internet number resource',
        inputBtn: 'Add',
        inputLimitRemindingMsg: 'Compare up to six Internet number resources.',
        inputLimitErrorMsg: 'Maximum six Internet number resources.',
        inputDuplicateErrorMsg: 'Resource has been selected.',
      },
      tools: {
        tab: 'Step 2',
        title: 'Add the info tool(s) you want to compare:',
        titleAfterSelection: 'Selected info tools.',
        viewToolsBtn: 'Select info tools',
        selectionModalTitle: 'Add info tools(s)',
        selectionModalTitleOnMobile: 'Set of info tools',
        selectionCategoryModalOnMobile: 'Select a tools category',
        selectionToolsModalOnMobile: 'Select tool(s)',
        selectionInputPlaceholder: 'Search info tool',
        selectionLimitRemindingMsg: 'Select up to six info tools',
        selectionLimitWarningMsg: 'You can select up to six info tools.',
        categoryAll: 'All',
        categoryRoutingTools: 'Routing tools',
        categoryDatabase: 'Database',
        categoryActivity: 'Activity',
        selectionAddBtn: 'Add',
        selectionApplyBtn: 'Apply',
        selectionCancelBtn: 'Cancel',
      },
      results: {
        submitBtn: 'Submit',
        hideBtn: 'Hide',
        showBtn: 'Show',
        promptNotAvailable:
          'This tool is not available for the selected Internet number resources.',
        promptNotAvailableForCurrentResource:
          'This tool is not available for this Internet number resource.',
      },
    },
  },
  zh_hans: {
    mobile: {
      welcome: '欢迎来到 NetOX',
      subtitle: 'Recommendation',
      warning: '在此阶段，如果您从电脑进行访问，将会获得更好的体验。',
      close: 'Close',
    },
    sidebar: {
      home: '首页',
      dashboard: '概览',
      usefulLinks: '便捷链接',
      disclaimer: '声明',
      discover: '探索更多工具',
    },
    navbar: {
      login: '登录',
      hi: '您好',
      logout: '登出',
      profile: '个人设置',
      myapnic: 'MyAPNIC 概览',
      training: '培训',
      academy: '学院',
      blog: '博客',
      internetDirectory: '互联网目录',
    },
    searchBox: {
      title: 'NetOX',
      subtitle: "互联网运营商工具箱 Network Operators' toolboX",
      subHeader:
        '这套工具，可以供互联网运营商获取有关自己和其他网络的信息,从而可以解决路由问题，以及在有更好的了解后做出网络决策',
      eg: '例如',
      search: '搜索',
      searchHint: '输入互联网数字资源',
      or: '或',
      warningText: '请输入有效格式，例如:AS15169 或 8.8.8.0/24',
    },
    welcomePage: {
      discoverMore: '发现更多',
      tools: {
        title: '发现所有工具',
        description: '探索类别以获取每组工具的摘要',
      },
      startUsing:
        '从现在开始使用 NetOX 解决路由问题，以及在有更好的了解后做出网络决策',
      exampleTitle: '该概览用于显示数据，举例 | ',
      otherNetworkInfo: {
        title: '其他网络信息',
        description: '查找路由信息，决定连接到哪些其他网络',
        items: [
          {
            text: '谁有更多对等体，AS1或AS2？',
            link: '查看“概览”类别',
            example:
              'CAIDA AS关系工具是用于提供指定AS的对等体的工具。 | 使用搜索框输入另一个AS。',
          },
          {
            text: '上行运营商的网络中断情况如何？',
            link: '查看“路由”类别',
            example:
              '这些工具可提供与BGP路由中断的影响有关的信息。| 使用搜索框输入另一个前缀。',
          },
          {
            text: '您想要的前缀或ASN在BGP中是否已经可见？',
            link: '查看“质量检查”类别',
            example:
              '这些工具可提供信息，以评估其他路由方面的资源质量。｜ 使用搜索框输入另一个AS或前缀。',
          },
          {
            text: '哪个ASN宣布IP？',
            link: '查看“路由”类别',
            example:
              '这些工具可提供与前缀或AS的通告相关的信息。 | 使用搜索框输入另一个AS或前缀。',
          },
          {
            text: '您向哪里可以报告IP滥用情况？',
            link: '查看“反滥用”类别',
            example:
              '这些工具可提供有关列入黑名单的IP资源以及用于报告滥用情况的联系人的信息。 | 使用搜索框输入另一个前缀。',
          },
        ],
      },
      yourNetworkInfo: {
        title: '您的网络 | 信息',
        description: '查找路由信息以进行调试和 | 解决您的网络',
        items: [
          {
            text: '有人宣布您的前缀吗？',
            link: '查看“路由”类别',
            example:
              '这些工具可提供与前缀或AS的通告相关的信息。 | 使用搜索框输入您的AS或前缀。',
          },
          {
            text: '您的新IPv6网络可见度如何？',
            link: '查看“路由”类别',
            example:
              '这些工具可提供与前缀或AS的可见度相关的信息。 | 使用搜索框输入您的AS或前缀。',
          },
          {
            text: '您的BGP路由与路由注册表一致吗？',
            link: '查看“路由”类别',
            example:
              '这些工具可提供与BGP路由相关的信息。 | 使用搜索框输入您的AS或前缀。',
          },
          {
            text: '您的前缀是否已列入黑名单？',
            link: '查看“反滥用”类别',
            example:
              ' 这些工具可提供有关列入黑名单的IP资源以及用于报告滥用情况的联系人的信息。 | 使用搜索框输入您的前缀。 ',
          },
          {
            text: '您的前缀在某经济体中昨天可以看到吗？',
            link: '查看“地理位置”类别',
            example:
              '这些是提供当前和过去地理位置信息的工具。｜使用搜索框输入您的前缀。',
          },
        ],
      },
      poweredBy: '由 | RIPE NCC’s RIPEstat提供支持',
    },
    discoverPage: {
      header: '发现更多工具',
      title: '获取有关您和其他网络的更多信息',
      p1: '查看这些免费工具，以帮助解决您的路由问题并制定更明智的网络决策。',
      p2: '需要使用其他来源进一步分析所选的互联网号码资源，并验证此信息，请使用：',
      p3: 'Hurricane Electric’s BGP toolkit',
      p4: '需要浏览所选互联网号码资源的资源公钥基础结构（RPKI）信息， 请使用：',
      p5: 'Cloudflare’s RPKI',
      p6: '需要工具和API来查看实时和历史BGP数据，请使用：',
      p7: 'CAIDA’s BGPstream',
      p8: '请随时关注以下Twitter帐户中的BGP事件，例如中断或劫持：',
      p9: 'Cisco’s BGPstream Twitter account',
      p10: '查找有关AS的IPv6用户的信息。 在选择要连接的网络或选择上行运营商时可能会有所帮助：',
      p11: 'APNIC Labs IPv6 populations',
      p12: '使用以下方法确定和解决与所选互联网号码资源相关的与资源公钥基础结构（RPKI）相关的问题：',
      p13: "NLnet Labs' JDR",
    },
    disclaimerPage: {
      header: '免责声明',
      p1: '尽管APNIC会采取所有合理的措施来确保此数据的准确性和有效性，但我们不控制也因此不保证数据的完整准确性，完整性和可用性。',
      p2: '该站点中的工具使用来自不由APNIC验证的外部数据源的数据。这些工具无意被视为任何形式的权威性声明，而应仅将其用作信息服务。',
      p3: '特别是，对于“资源质量检查”部分，该部分中包括的工具旨在帮助评估资源的质量，但是不能保证这种质量。在依赖本网站提供的任何信息或数据之前，您应该进行自己的调查。',
      p4: '对于使用此数据可能引起的任何损失或损害，APNIC不承担任何责任。',
    },
    tabs: {
      'apnic-at-a-glance': {
        name: '概览',
        info: '用于查看AS或前缀概览的关键工具',
      },
      'apnic-rqc': {
        name: '质量检查',
        info: '提供信息以评估资源质量的工具，包括分配，路由，地理位置和黑名单状态',
      },
      'apnic-routing': { name: '路由', info: '提供与BGP路由相关的信息的工具' },
      'apnic-anti-abuse': {
        name: '反滥用',
        info: '提供有关列入黑名单的IP资源和联系信息的工具，以报告滥用情况',
      },
      'apnic-database': {
        name: '数据库',
        info: '提供注册表信息的工具（WHOIS和IRR信息）',
      },
      'apnic-geo': {
        name: '地理位置',
        info: '提供当前和历史地理位置信息的工具',
      },
      'apnic-activity': {
        name: '活动',
        info: '提供有关网络和互联网测量活动信息的工具',
      },
      'apnic-experimental': {
        name: '试验',
        info: 'no info',
      },
      'apnic-comparison': {
        name: '对比',
        info: '对比不同互联网号码资源的查询结果',
      },
    },
    experimentalMsg: {
      title: '您正在查看处于测试的新工具，因此您可能会遇到一些问题。',
      body: '这是一个试验性页面，其中包含正在测试的新工具，以确定您是否认为它们有用。请注意，数据来自第三方，您可能会遇到一些问题。很抱歉给您带来不便。',
    },
    footer: {
      privacy: '隐私',
      contact: '联系',
      helpdesk: '支持中心',
      nroNews: 'NRO 新闻',
      serviceStatus: '服务状态',
      careers: '招聘',
      connect: '与我们联系',
    },
    comparisonFeature: {
      resources: {
        tab: '第一步',
        title: '输入您想要对比的互联网号码资源:',
        inputPlaceholder: '输入互联网号码资源',
        inputBtn: '添加',
        inputLimitRemindingMsg: '可对比最多6个互联网号码资源',
        inputLimitErrorMsg: '最多6个互联网号码资源',
        inputDuplicateErrorMsg: '该资源已存在',
      },
      tools: {
        tab: '第二步',
        title: '添加您想要对比的工具:',
        titleAfterSelection: '已选择的工具',
        viewToolsBtn: '选择工具',
        selectionModalTitle: '添加工具',
        selectionModalTitleOnMobile: '可选择的工具',
        selectionCategoryModalOnMobile: '选择工具类别',
        selectionToolsModalOnMobile: '选择工具',
        selectionInputPlaceholder: '搜索工具',
        selectionLimitRemindingMsg: '可选择最多6个工具',
        selectionLimitWarningMsg: '最多6个工具',
        categoryAll: '全部',
        categoryRoutingTools: '路由',
        categoryDatabase: '数据库',
        categoryActivity: '活动',
        selectionAddBtn: '添加',
        selectionApplyBtn: '应用',
        selectionCancelBtn: '取消',
      },
      results: {
        submitBtn: '提交',
        hideBtn: '隐藏',
        showBtn: '显示',
        promptNotAvailable: '这个工具不适用于已输入的互联网号码资源',
        promptNotAvailableForCurrentResource:
          '这个工具不适用于此互联网号码资源',
      },
    },
  },
  zh_hant: {
    mobile: {
      welcome: '歡迎來到 NetOX',

      warning: '建議使用電腦來瀏覽此網頁以得到較好的使用者體驗',
    },
    sidebar: {
      home: '首頁',
      dashboard: '儀表板',
      usefulLinks: '快速連結',
      disclaimer: '聲明',
      discover: '探索更多工具',
    },
    navbar: {
      login: '登入',
      hi: '您好',
      logout: '登出',
      profile: '個人設定',
      myapnic: 'MyAPNIC 概覽',
      training: '培訓',
      academy: '學院',
      blog: '部落格',
      internetDirectory: '網路目錄',
    },
    searchBox: {
      title: 'NetOX',
      subtitle: "網路營運工具箱 Network Operators' toolboX",
      subHeader:
        '這套工具可以提供網路營運人員獲取有關自己和其他網路的訊息，從而解決路由問題，以及在您需要做出網路相關決策時提供多樣資訊已協助您做出更好的決定',
      eg: '例如',
      search: '搜尋',
      searchHint: '輸入網路資源編號',
      or: '或',
      warningText: '請輸入有效格式，例如:AS15169 或 8.8.8.0/24',
    },
    welcomePage: {
      discoverMore: '探索更多',
      tools: {
        title: '探索所有工具',
        description: '探索類別以獲去每組工具的摘要',
      },
      startUsing:
        '從現在開始使用 NetOX 解決路由問題，以及在您需要做豬網路相關決策時獲取更多資訊',
      exampleTitle: '以 | 為例，儀表板是用來顯示該資料的',
      otherNetworkInfo: {
        title: '其他網路 | 訊息',
        description: '尋找路由訊息來決定連接到哪些｜其他網路',
        items: [
          {
            text: '誰有更多的對等節點, AS1 or AS2?',
            link: "查看'概覽'類別",
            example:
              'CAIDA AS 關係工具 是以提供的AS來顯示相關的對等節點 | 請使用搜尋列來輸入其他的AS',
          },
          {
            text: '上行營運商的網路中斷情況如何?',
            link: "查看'路由'類別",
            example:
              '這些工具是用來顯示當BGP路由中斷時所相對應的影響 | 請使用搜尋列來輸入其他的前綴',
          },
          {
            text: '您想要的前綴或ASN是否已在BGP中?',
            link: "查看'品質管理'類別",
            example:
              '這些工具是用來測試該路由的資源品質 | 請使用搜尋列來輸入其他的AS或前綴',
          },
          {
            text: '哪個ASN宣布IP?',
            link: "查看'路由'類別",
            example:
              '這些工具是用來顯示前綴或AS相關的宣告 | 請使用搜尋列來輸入其他的前綴',
          },
          {
            text: '哪裡可以舉報IP濫用的情況?',
            link: "查看'反濫用'類別",
            example:
              '這些工具是用來顯示IP資源的黑名單以及回報濫用的聯絡單位的相關資料 | 請使用搜尋列來輸入其他前綴',
          },
        ],
      },
      yourNetworkInfo: {
        title: '您的網路 | 資訊',
        description: '尋找路由相關資訊以進行除錯｜困難排解您的網路',
        items: [
          {
            text: '您的前綴遭其他人使用嗎？?',
            link: "查看'路由'類別",
            example:
              '這些工具是用來顯示前綴或AS的相關宣告 | 請使用搜尋列來輸入其他的前綴或AS',
          },
          {
            text: '您的新IPv6可見度如何?',
            link: "查看'路由'類別",
            example:
              '這些工具是用來顯示前綴或AS的可見度的相關資料 | 請使用搜尋列來輸入其他的前綴或AS',
          },
          {
            text: '您的BGP路由與路由註冊表一致嗎?',
            link: "查看'路由'類別",
            example:
              '這些工具是用來顯示關於BGP路由的相關資料 | 請使用搜尋列來輸入其他的前綴',
          },
          {
            text: '您的前綴已進入黑名單了嗎?',
            link: "查看'反濫用'類別",
            example:
              '這些工具是用來顯示IP資源的黑名單以及回報濫用的聯絡單位的相關資料 | 請使用搜尋列來輸入其他的前綴',
          },
          {
            text: '您的前綴在某經濟體中是否於在昨日依然可見?',
            link: "查看'地理位置'類別",
            example:
              '這些工具是用來顯示現在與過去的地理位置相關資料 | 請使用搜尋列來輸入其他的前綴',
          },
        ],
      },
      poweredBy: '資訊由 | RIPE NCC’s RIPEstat 提供',
    },
    discoverPage: {
      header: '發掘更多工具',
      title: '取得更多關於你或其他人的網路資訊',
      p1: '使用這些免費的工具來幫助你解決路由問題以及做出更明智的決策',
      p2: '進一步分析網路號碼資源，以及使用其他資源驗證所取得的資訊，請使用：',
      p3: 'Hurricane Electric’s BGP toolkit',
      p4: '探索選定的網路號碼資源相關的RPKI資訊，請使用：',
      p5: 'Cloudflare’s RPKI',
      p6: '取得相關工具或API以觀察即時或過去的BGP資料，請使用：',
      p7: 'CAIDA’s BGPstream',
      p8: '取得關於BGP最新的資訊，例如網路中斷或者網路劫持，請跟隨以下Twitter帳戶：',
      p9: 'Cisco’s BGPstream Twitter account',
      p10: '查找有關AS的IPv6用戶的信息。在選擇要連接的網絡或選擇上行運營商時可能會有所幫助：',
      p11: 'APNIC Labs IPv6 populations',
      p12: '使用以下的方法確定與解決和所選網路號碼資源與資源公鑰基礎結構（RPKI）有關的問題：',
      p13: "NLnet Labs' JDR",
    },
    disclaimerPage: {
      header: '免責聲明',
      p1: '儘管APNIC會採取一切合理措施確保此數據的準確性和有效性，但我們不控制也因此不保證數據的完全準確性、完整性和可用性。',
      p2: '網站中的小工具使用來自不經APNIC驗證的外部數據，這些小工具無意被視為任何形式的官方聲明，而應僅將其用作信息服務。',
      p3: '特別是對於”資源品質檢測“的項目，該項目中包含的小工具旨在幫助評估資源的品質，但是不能用於保證該品質。在信賴本網站所提供的任何信息前，請先自行查核及評估。',
      p4: '對於使用此網站數據可能引起的任何損失，APNIC將不承擔任何責任。',
    },
    tabs: {
      'apnic-at-a-glance': {
        name: '概覽',
        info: '用於快速查看AS或前綴的關鍵工具',
      },
      'apnic-rqc': {
        name: '品質管理',
        info: '提供訊息已評估資源品質的工具，該資訊包含分配、路由、地理位置和黑名單狀態',
      },
      'apnic-routing': { name: '路由', info: '提供與BGP路由相關的訊息工具' },
      'apnic-anti-abuse': {
        name: '反濫用',
        info: '提供有關列入黑名單的IP資源和相關訊息的工具，以舉報濫用的情況',
      },
      'apnic-database': {
        name: '資料庫',
        info: '提供註冊表訊息的工具 (WHOIS and IRR 訊息)',
      },
      'apnic-geo': {
        name: '地理位置',
        info: '提供當前和歷史的地理位置訊息的工具',
      },
      'apnic-activity': {
        name: '活動',
        info: '提供有關測量網路活動訊息的工具',
      },
      'apnic-experimental': {
        name: '實驗',
        info: 'no info',
      },
      'apnic-comparison': {
        name: '對比',
        info: '對比不同網路號碼資源的查詢結果',
      },
    },
    experimentalMsg: {
      title: '你正在查看處於測試的新工具，因此您可能會遇到一些問題',
      body: '這是一個實驗性頁面，其中包含正在測試的新工具，已確定您是否認為他們有用。請注意，數據來自第三方，您可能會遇到一些問題，很抱歉給您帶來不便。',
    },
    footer: {
      privacy: '隱私權',
      contact: '聯絡APNIC',
      helpdesk: '支援',
      nroNews: 'NRO 新聞',
      serviceStatus: '服務狀態',
      careers: '工作機會',
      connect: '關注APNIC',
    },
    comparisonFeature: {
      resources: {
        tab: '第一步',
        title: '輸入您想要對比的網路號碼資源:',
        inputPlaceholder: '輸入網路號碼資源',
        inputBtn: '添加',
        inputLimitRemindingMsg: '可對比最多6個網路號碼資源',
        inputLimitErrorMsg: '最多6個網路號碼資源',
        inputDuplicateErrorMsg: '該資源已被選取',
      },
      tools: {
        tab: '第二步',
        title: '添加您想要對比的工具: ',
        titleAfterSelection: '已選擇的工具',
        viewToolsBtn: '選擇工具',
        selectionModalTitle: '添加工具',
        selectionModalTitleOnMobile: '可選擇的工具',
        selectionCategoryModalOnMobile: '選擇工具類別',
        selectionToolsModalOnMobile: '選擇工具',
        selectionInputPlaceholder: '搜尋工具',
        selectionLimitRemindingMsg: '可選擇最多6個工具',
        selectionLimitWarningMsg: '最多6個工具',
        categoryAll: '全部',
        categoryRoutingTools: '路由',
        categoryDatabase: '數據庫',
        categoryActivity: '活動',
        selectionAddBtn: '添加',
        selectionApplyBtn: '應用',
        selectionCancelBtn: '取消',
      },
      results: {
        submitBtn: '送出',
        hideBtn: '隱藏',
        showBtn: '顯示',
        promptNotAvailable: '這個工具不適用於已輸入的網路號碼資源',
        promptNotAvailableForCurrentResource: '这个工具不適用於此網路號碼資源',
      },
    },
  },
  ja: {
    mobile: {
      welcome: 'NetOXへようこそ',
      subtitle: 'レコメンデーション',
      warning:
        '現時点では、デスクトップデバイスからアクセスした方がより快適にご利用いただけます',
      close: '閉じる',
    },
    sidebar: {
      home: 'ホーム',
      dashboard: 'ダッシュボード',
      usefulLinks: '役に立つリンク集',
      disclaimer: '免責事項',
      discover: 'その他のツール',
    },
    navbar: {
      login: 'ログイン',
      hi: 'Hi',
      logout: 'ログアウト',
      profile: 'パーソナルセッティング',
      myapnic: 'MyAPNICダッシュボード',
      training: 'トレーニング',
      academy: 'アカデミー',
      blog: 'ブログ',
      internetDirectory: 'インターネットディレクトリ',
    },
    searchBox: {
      title: 'NetOX',
      subtitle:
        "Network Operators' toolboX (ネットワークオペレータのツールボックス) ",
      subHeader:
        '自身や他人のネットワークを分析し、ルーティングの問題を解決し、より良い情報に基づいた意思決定を行うためのツールセットです',
      eg: '例',
      search: '検索',
      or: 'もしくは',
      searchHint: 'インターネットリソースナンバーを入力',
      warningText: '有効な形式で入力してください。例: AS15169 or 8.8.8.0/24',
    },
    welcomePage: {
      discoverMore: 'さらに詳しく',
      tools: {
        title: 'すべてのツールを見る',
        description: 'カテゴリーを調べると、各ツールの概要を知ることができます',
      },
      startUsing:
        'ルーティングの問題を解決し、より良い情報に基づいた意思決定を行うために、今すぐNetOXの利用を開始しましょう',
      exampleTitle: 'ダッシュボードには、例えばこんなデータが表示されています',
      otherNetworkInfo: {
        title: 'あなた以外のネットワーク情報',
        description:
          'どの他のネットワークに接続するかを決定するためのルーティング情報を検索します',
        items: [
          {
            text: 'AS1とAS2、どちらがより多くのピアを持っているか?',
            link: 'カテゴリーを表示',
            example:
              'CAIDA AS リレーションシップは指定されたASのピアについてお知らせするツールです。検索ボックスにあなた以外のASを入力してください。',
          },
          {
            text: '上流の障害状況はどうでしょうか?',
            link: 'ルーティングのカテゴリーを表示',
            example:
              '障害発生時のBGPルーティングへの影響に関連する情報を提供するツールです。検索ボックスにあなた以外のプレフィックスを入力してください。',
          },
          {
            text: 'ご希望のプレフィックスやASNは、すでにBGPで見えていますか?',
            link: 'クオリティチェックのカテゴリーを表示',
            example:
              'これらは、特にルーティングの観点でリソースクオリティを評価するための情報を提供するツールです。検索ボックスにあなた以外のASやプレフィックスを入力してください。',
          },
          {
            text: 'どのASNがIPアドレスをアナウンスしていますか?',
            link: 'ルーティングのカテゴリーを表示',
            example:
              'プレフィックスやASのアナウンスに関連する情報を提供するためのツールです。検索ボックスにあなた以外のプレフィックスを入力してください。',
          },
          {
            text: 'IPアドレスからabuseを報告するには?',
            link: 'Anti Abuseのカテゴリーを表示',
            example:
              'ブラックリストに登録されたIPリソースやabuseを報告するための窓口に関する情報を提供するツールです。検索ボックスにあなた以外のプレフィックスを入力してください。',
          },
        ],
      },
      yourNetworkInfo: {
        title: 'あなたのネットワーク情報',
        description:
          'ネットワークのデバッグやトラブルシューティングのためのルーティング情報を検索',
        items: [
          {
            text: 'あなたのプレフィックスをアナウンスしている人がいますか？',
            link: 'ルーティングのカテゴリーを表示',
            example:
              'プレフィックスやASのアナウンスに関連する情報を提供するためのツールです。検索ボックスにあなたのプレフィックスを入力してください。',
          },
          {
            text: 'あなたの新しいIPv6ネットワークはどのくらい見えていますか?',
            link: 'ルーティングのカテゴリーを表示',
            example:
              'プレフィックスやASのアナウンスに関連する情報を提供するためのツールです。検索ボックスにあなたのプレフィックスを入力してください。',
          },
          {
            text: 'BGPルーティングがRouting Registryと一致していますか？',
            link: 'ルーティングのカテゴリーを表示',
            example:
              'BGPルーティングに関連する情報を提供するためのツールです。検索ボックスにあなたのプレフィックスを入力してください。',
          },
          {
            text: 'あなたのプレフィックスはブラックリストに登録されていませんか?',
            link: 'Anti Abuseのカテゴリーを表示',
            example:
              'ブラックリストに登録されたIPリソースやabuseを報告するための窓口に関する情報を提供するツールです。検索ボックスにあなたのプレフィックスを入力してください。',
          },
          {
            text: '昨日、特定の経済圏であなたのプレフィックスが表示されていましたか?',
            link: 'ジオグラフィックのカテゴリーを表示',
            example:
              '現在および過去のジオロケーション情報を提供するツールです。 検索ボックスにあなたのプレフィックスを入力してください。',
          },
        ],
      },
      poweredBy: 'Powered by | RIPE NCC RIPEstat',
      JaTranslationBy: 'JPNIC | による日本語訳',
    },
    discoverPage: {
      header: 'その他のツール',
      title: '自分や他のネットワークについて、さらに詳しい情報を得る',
      p1: 'ルーティングの問題を解決し、より良い情報に基づいたネットワークの意思決定を行うために、これらの無料ツールをチェックしてみてください',
      p2: '選択したインターネット番号資源をさらに分析し、この情報を別のソースで検証するには:',
      p3: 'Hurricane Electric BGP toolkit',
      p4: '選択したインターネット番号資源のRPKI (the Resource Public Key Infrastructure) の情報を調査するには:',
      p5: 'Cloudflare RPKI',
      p6: '現在や過去のBGPデータを閲覧するためのツールやAPIを入手するには:',
      p7: 'CAIDA BGPstream',
      p8: '障害やハイジャックなどのBGPイベントについては、以下のTwitterアカウントで随時お知らせしています:',
      p9: 'Cisco BGPstream Twitter account',
      p10: 'ASのIPv6ユーザーに関する情報を検索できます。接続するネットワークを選択する際や、上流プロバイダーを採用する際に役立つことがあります:',
      p11: 'APNIC Labs IPv6 populations',
      p12: '選択したインターネット番号資源に関連するRPKI (the Resource Public Key Infrastructure) 関連の問題を特定し、トラブルシューティングを行うには:',
      p13: "NLnet Labs' JDR",
    },
    disclaimerPage: {
      header: '免責事項',
      p1: 'APNICは、本データの正確性と妥当性を確保するためにあらゆる合理的な注意を払っていますが、本データの完全な正確性、完全性、可用性を管理するものではなく、したがって保証するものではありません。',
      p2: '本サイトのウィジェットは、APNICが検証していない外部データソースからデータを取得しています。これらのウィジェットは、いかなる種類の権威ある声明として考えられるものではなく、情報提供サービスとしてのみ使用されるべきものです。',
      p3: '特にリソースクオリティチェックのセクションでは、そのセクションに含まれるウィジェットはリソースのクオリティを評価する一助となることを意図していますが、そのクオリティを保証するものではありません。本サイトで提供される情報や日付に依存する前に、ご自身で調査されることをお勧めします。',
      p4: 'APNICは、本データの使用により発生したいかなる損失や損害に対しても、一切の責任を負いません。',
    },
    tabs: {
      'apnic-at-a-glance': {
        name: 'カテゴリー',
        info: 'ASやプレフィックスの概要を把握するための主要ツール',
      },
      'apnic-rqc': {
        name: 'クオリティチェック',
        info: '委任、ルーティング、ジオロケーション、ブラックリストの状態などの観点からリソースのクオリティを評価するための情報を提供するツール',
      },
      'apnic-routing': {
        name: 'ルーティング',
        info: 'BGPルーティングに関連する情報を提供するツール',
      },
      'apnic-anti-abuse': {
        name: 'Anti Abuse',
        info: 'ブラックリストに登録されたIPリソースやabuseを報告するための窓口に関する情報を提供するツール',
      },
      'apnic-database': {
        name: 'データベース',
        info: 'レジストリ情報（WHOIS、IRR情報）を提供するツール',
      },
      'apnic-geo': {
        name: 'ジオグラフィック',
        info: '現在および過去のジオロケーション情報を提供するツール',
      },
      'apnic-activity': {
        name: 'アクティビティ',
        info: 'ネットワークやインターネットの計測アクティビティに関する情報を提供するツール',
      },
      'apnic-experimental': {
        name: '実験',
        info: '情報なし',
      },
      'apnic-comparison': {
        name: '比較',
        info: '異なるインターネット番号資源の結果を比較する',
      },
    },
    experimentalMsg: {
      title:
        'あなたは、私たちがテストしている新しいツールを閲覧しています。この段階では、いくつかの問題が発生する可能性があります。',
      body: 'このページは、これらのツールがお客様にとってどの程度価値があるのかを把握するための実験的なページです。このページは、第三者から提供されたデータを表示しており、いくつかの問題が発生する可能性があります。ご不便をおかけして申し訳ございません。',
    },
    footer: {
      privacy: 'プライバシー',
      contact: '連絡先',
      helpdesk: 'ヘルプセンター',
      nroNews: 'NROニュース',
      serviceStatus: 'サービスステータス',
      careers: 'キャリア',
      connect: 'お問い合わせはこちら',
    },
    comparisonFeature: {
      resources: {
        tab: 'ステップ1',
        title: '比較したいインターネット番号資源を入力します:',
        inputPlaceholder: 'インターネット番号資源を入力',
        inputBtn: '追加',
        inputLimitRemindingMsg:
          '最大6つのインターネット番号資源を比較することができます',
        inputLimitErrorMsg: '最大6つのインターネット番号資源',
        inputDuplicateErrorMsg: 'リソースが選択されました',
      },
      tools: {
        tab: 'ステップ2',
        title: '比較したい情報ツールを追加します:',
        titleAfterSelection: '選択された情報ツール',
        viewToolsBtn: '情報ツールを選択します',
        selectionModalTitle: '追加された情報ツール',
        selectionModalTitleOnMobile: '情報ツールをセット',
        selectionCategoryModalOnMobile: 'ツールのカテゴリーを選択します',
        selectionToolsModalOnMobile: 'ツールを選択します',
        selectionInputPlaceholder: '情報ツールを検索します',
        selectionLimitRemindingMsg: '情報ツールは最大6つまで選択します',
        selectionLimitWarningMsg: '情報ツールは最大6つまで選択可能です',
        categoryAll: 'すべて',
        categoryRoutingTools: 'ルーティングツール',
        categoryDatabase: 'データベース',
        categoryActivity: 'アクティビティ',
        selectionAddBtn: '追加',
        selectionApplyBtn: '適用',
        selectionCancelBtn: 'キャンセル',
      },
      results: {
        submitBtn: '送信',
        hideBtn: '非表示',
        showBtn: '表示',
        promptNotAvailable:
          'このツールは選択されたインターネット番号資源では利用できません',
        promptNotAvailableForCurrentResource:
          'このツールはこのインターネット番号資源では利用できません',
      },
    },
  },
};

export default new VueI18n({ locale: 'en', messages });
